import React from 'react';
import { Fab, Zoom, useScrollTrigger } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import useWidgetContext from 'src/hooks/useWidgetContext';

const useStyles = makeStyles(() => ({
  fab: {
    position: 'absolute',
    bottom: ({ showMenu }) => (showMenu ? '240px' : '90px'),
    right: '40px'
  }
}));

const ScrollTopButton = ({ scrollUpTop, contentWrapper }) => {
  const {
    state: { showMenu }
  } = useWidgetContext();
  const classes = useStyles({ showMenu });
  const isScrollTriggered = useScrollTrigger({
    disableHysteresis: true,
    threshold: 1000,
    target: contentWrapper
  });
  const theme = useTheme();
  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };

  return (
    <Zoom in={isScrollTriggered} timeout={transitionDuration} unmountOnExit>
      <Fab className={classes.fab} onClick={scrollUpTop}>
        <ArrowUpwardIcon />
      </Fab>
    </Zoom>
  );
};

ScrollTopButton.propTypes = {
  scrollUpTop: PropTypes.func,
  contentWrapper: PropTypes.object
};

export default ScrollTopButton;
